var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankKdb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26068 11.8019C5.92233 12.2947 5.90457 13.105 6.25902 13.6158L10.0291 19.0927C10.3706 19.5792 11.151 20 11.9485 20H17L10.085 9.96585C9.58298 9.23994 9.17617 7.73095 9.57517 7L6.26068 11.8019Z",
    fill: "url(#paint0_radial_10834_56417)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3612 5C10.54 5 9.8886 5.36434 9.53847 5.92321L9.15052 6.53533C8.77806 7.27893 9.15782 8.81404 9.6265 9.55252L11.8073 13C11.5463 12.4783 11.7036 11.8346 11.8746 11.5643L16 5H11.3612Z",
    fill: "url(#paint1_radial_10834_56417)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3L21.2863 13.0343C21.7429 13.7595 22.1115 15.2684 21.75 16L24.7623 11.1982C25.0705 10.7047 25.0869 9.8944 24.7649 9.38357L21.3369 3.90643C21.0269 3.42058 20.3172 3 19.5926 3H15Z",
    fill: "url(#paint2_radial_10834_56417)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1251 11.4359L15 18H19.639C20.4603 18 21.1128 17.6353 21.4621 17.0756L21.85 16.4643C22.2212 15.7201 21.8428 14.1855 21.3738 13.4478L19.193 10C19.4532 10.5227 19.2977 11.1657 19.1251 11.4359Z",
    fill: "url(#paint3_radial_10834_56417)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10834_56417",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.16069 11.0692) rotate(-90) scale(12.3108 14.6895)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731128,
    stopColor: "#CCE3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9ACAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311878,
    stopColor: "#9ACAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#406DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741252,
    stopColor: "#406DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18397A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10834_56417",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0369 4.83332) scale(8.78847 8.85426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731128,
    stopColor: "#CCE3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9ACAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311878,
    stopColor: "#9ACAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#406DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741252,
    stopColor: "#406DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18397A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10834_56417",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8507 11.9266) rotate(90) scale(12.3107 13.3534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731128,
    stopColor: "#CCE3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9ACAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311878,
    stopColor: "#9ACAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#406DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741252,
    stopColor: "#406DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18397A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10834_56417",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9631 18.1667) rotate(180) scale(8.79084 8.85443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731128,
    stopColor: "#CCE3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9ACAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311878,
    stopColor: "#9ACAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#406DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741252,
    stopColor: "#406DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18397A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankKdb);
export default __webpack_public_path__ + "static/media/BankKDB.32ab2ba71aceabbcaba203b05b5b882f.svg";
export { ForwardRef as ReactComponent };